export default __webpack_public_path__ + "static/media/folder-search.20681ede.svg";